/**
 * Created by forbiz on 2019-02-11.
 */

const greatingLifeDetail = () => {
    hdFn.hdSlide('.relation-product__box', {
        arrows: false,
        autoplay: false,
        autoplaySpeed: 1000,
        appendDots: $(".relation-product__box__pager"),
        dots: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        speed: 1000,
    });
    
};

export default greatingLifeDetail;